import React from 'react';

import { createRoot } from 'react-dom/client';

import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { $placementsMap } from '@client/core/atoms/placements.js';
import { getInViewSettingsByBrand } from '@client/core/utils/getInViewSettingsByPlacementId.js';
import { RenderSponsoredContentOrChildren } from '@client/sponsoredContent/RenderSponsoredContentOrChildren.js';
import {
  AdServer,
  type PlacementId,
  Placements,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

import GamAdUnit from './GamAdUnit.js';

export function renderGamAd(
  placementId: PlacementId,
  containerElement: Element | null
) {
  const placementElement = containerElement && createRoot(containerElement);
  const inViewSettings = getInViewSettingsByBrand(placementId);

  if (!placementElement) return;

  const placements = $placementsMap.get();

  if (Object.keys(placements).length === 0) {
    console.error(`No placements found`);
    updateMetricByKey(placementId, PlacementStatus.NotInConfig);
    return;
  }

  const placement = placements[placementId];

  if (!placement) {
    console.error(`PlacementId: ${placementId} not found`);
    return;
  }

  if (!Placements.Gam.is(placement)) return;

  const Children = (
    <GamAdUnit placement={placement} inViewSettings={inViewSettings} />
  );

  placementElement.render(
    placement.overrideAdServer === AdServer.SponsoredContent ? (
      <RenderSponsoredContentOrChildren placement={placement}>
        {Children}
      </RenderSponsoredContentOrChildren>
    ) : (
      Children
    )
  );
}
